import { render, staticRenderFns } from "./pedidos.vue?vue&type=template&id=63d058ce&scoped=true&"
import script from "./pedidos.vue?vue&type=script&lang=js&"
export * from "./pedidos.vue?vue&type=script&lang=js&"
import style0 from "./pedidos.vue?vue&type=style&index=0&id=63d058ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d058ce",
  null
  
)

export default component.exports